import {HttpMethod, httpClient} from './httpClient';

export const LaunchNewJob = (data:any = {}): Promise<any> => {
  return httpClient(`job_templates/9/launch/`, HttpMethod.Post, data);
};

export const GetStatus = (data:any = {}): Promise<any> => {
  return httpClient(`jobs/${data.id}`, HttpMethod.Post, data);
};

export const GetResult = (data:any = {}): Promise<any> => {
  return httpClient(`jobs/${data.id}/stdout/?format=txt`, HttpMethod.Get, data);
};
